import { type EntityName, entityRegistry } from '@app/icare/entities/registry'
import type { EntityId } from '@pkg/db/schema'
import { getTableById } from '@pkg/db/utils'
import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/goto/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()

  const config = entityRegistry[getTableById(id as EntityId<EntityName>)]

  if (!config) {
    return <div>Unknown Entity: {id}</div>
  }

  return <Navigate to={config.route?.edit} params={{ id } as never} replace />
}
